import {ApiClientService} from '@dofleini/security';
import {message, Upload} from 'antd';
import {useCallback, useEffect, useState} from 'react';

import {authentication, i18n} from '@/settings';

const maxFileUploadSize = process.env.REACT_APP_MAX_FILE_UPLOAD_SIZE || 20;

const getBase64 = (img, callback) => {
  // eslint-disable-next-line no-undef
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const checkUploadFileSize = (file, maxSize = maxFileUploadSize) => {
  const isLtSize = file.size / 1024 / 1024 < maxSize;
  if (!isLtSize) {
    message.error(i18n.t('uploadMaxSize', {size: maxSize, name: file?.name}));
  }
  return isLtSize;
};

const beforeUploadImage = (file, maxSize = maxFileUploadSize) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt2M = checkUploadFileSize(file, maxSize);
  return isJpgOrPng && isLt2M;
};

const beforeUpload = (file, isImage = true) => {
  let result;
  if (isImage)
    result = beforeUploadImage(file, maxFileUploadSize);
  else
    result = checkUploadFileSize(file, maxFileUploadSize);
  return result || Upload.LIST_IGNORE;
};

const useUploadAsset =
  (value,
    onChange = (v) => v,
    isImage = true,
    onlyImage = false,
    multiple = false,
    onUpdateFileList = (v) => v,
    actionUrl
  ) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImage] = useState(value);

    useEffect(() => {
      if (!multiple)
        setImage(value);
    }, [multiple, value]);

    const handleChange = useCallback(info => {
      if (info.file.status === 'uploading') {
        setLoading(true);
      }
      //
      onUpdateFileList(info);
      //
      if (info.file.status === 'error') {
        message.error('Upps, no hemos podido realizar esta acción');
        setLoading(false);
        onChange(multiple ? [] : null);
      }
      //
      if (info.file.status === 'done') {
        if (isImage)
          // Get this url from response in real world.
          getBase64(info.file.originFileObj, imageUrl => {
            setImage(imageUrl);
            const imageResult = onlyImage ? info.file.response?.image : info.file.response;
            if (multiple)
              onChange([...((typeof value === 'string' ? [value] : value) || []), imageResult]);
            else
              onChange(imageResult);
          });
        else {
          if (multiple) {
            onChange([...((typeof value === 'string' ? [value] : value) || []), info.file.response]);
          } else
            onChange(info.file.response);
        }
        setLoading(false);
      }
    }, [isImage, multiple, onChange, onUpdateFileList, onlyImage, value]);

    const authHeaders = ApiClientService.getToken() ? {Authorization: `Bearer ${ApiClientService.getToken()}`} : {};

    const props = {
      disabled: loading,
      action: `${ApiClientService.API_URL.replace(/\/$/, '')}${authentication.path}${actionUrl || `/api/files/${isImage ? 'image' : 'upload'}`}`,
      headers: {
        ...authHeaders,
        ...ApiClientService.defaultHeaders
      },
    };

    return {
      props,
      handleChange,
      imageUrl,
      loading
    };

  };

export {
  beforeUpload,
  beforeUploadImage,
  checkUploadFileSize,
  useUploadAsset
};
